var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9624 10.707L5.4624 8.2065L6.1689 7.5L7.9624 9.293L11.7549 5.5L12.4624 6.2075L7.9624 10.707Z",
    fill: "#020002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96241 1C7.57794 1 6.22456 1.41054 5.07341 2.17971C3.92227 2.94888 3.02506 4.04213 2.49525 5.32122C1.96544 6.6003 1.82681 8.00776 2.09691 9.36563C2.36701 10.7235 3.03369 11.9708 4.01266 12.9497C4.99163 13.9287 6.23891 14.5954 7.59677 14.8655C8.95464 15.1356 10.3621 14.997 11.6412 14.4672C12.9203 13.9373 14.0135 13.0401 14.7827 11.889C15.5519 10.7378 15.9624 9.38447 15.9624 8C15.9624 6.14348 15.2249 4.36301 13.9122 3.05025C12.5994 1.7375 10.8189 1 8.96241 1ZM8.96241 14C7.77572 14 6.61568 13.6481 5.62898 12.9888C4.64229 12.3295 3.87325 11.3925 3.41913 10.2961C2.965 9.19974 2.84618 7.99334 3.07769 6.82946C3.30921 5.66557 3.88065 4.59647 4.71976 3.75736C5.55888 2.91824 6.62798 2.3468 7.79186 2.11529C8.95575 1.88378 10.1621 2.0026 11.2585 2.45672C12.3549 2.91085 13.2919 3.67988 13.9512 4.66658C14.6105 5.65327 14.9624 6.81331 14.9624 8C14.9624 9.5913 14.3303 11.1174 13.205 12.2426C12.0798 13.3679 10.5537 14 8.96241 14Z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkOutline);
export default __webpack_public_path__ + "static/media/checkmarkOutline.67c6f36d541610fc31484efe5a9554e6.svg";
export { ForwardRef as ReactComponent };